import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { useRoute } from 'vue-router';
import ProgressReport from '@/views/Reports/ProgressReport';

export default /*@__PURE__*/_defineComponent({
  __name: 'ProgressReport',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(ProgressReport), {
    class: "p-0 w-full",
    "student-id": _unref(useRoute)().params.id
  }, null, 8, ["student-id"]))
}
}

})